var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47,
    fill: "url(#paint0_linear_2011_26)",
    stroke: "url(#paint1_radial_2011_26)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.8576 27.0638C66.4577 27.0638 67.0611 27.0392 67.6595 27.0687C69.1073 27.139 69.9189 27.9436 69.9713 29.399C70.3517 39.6639 66.9627 48.323 58.891 54.9199C57.253 56.2592 55.4019 57.3401 53.659 58.5536C53.2393 58.8463 52.9639 58.7514 52.6163 58.4031C47.9336 53.7097 43.2411 49.0278 38.5338 44.3606C38.16 43.991 38.1715 43.7244 38.4141 43.314C43.9756 33.888 51.8948 28.0531 63.0768 27.1783C64.0016 27.1063 64.9296 27.0589 65.8543 27C65.856 27.0213 65.8576 27.0425 65.8576 27.0638ZM56.7841 46.3442C60.1781 46.3442 62.9342 43.5953 62.9293 40.22C62.9227 36.8512 60.1469 34.0891 56.7693 34.094C53.3836 34.0989 50.6389 36.8479 50.6422 40.2347C50.6455 43.6345 53.3705 46.3442 56.7841 46.3442Z",
    fill: "url(#paint2_radial_2011_26)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8401 46.3312C41.508 50.9853 46.0021 55.4677 50.5356 59.9877C48.8911 60.6631 47.1613 61.2175 45.3398 61.3467C44.8643 61.381 44.2379 61.0981 43.8838 60.7547C41.2801 58.2298 38.706 55.6705 36.1826 53.0638C35.8137 52.6827 35.5268 51.9485 35.6153 51.4514C35.9187 49.7523 36.4056 48.0859 36.8401 46.3312Z",
    fill: "url(#paint3_radial_2011_26)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6729 58.2461C58.5516 59.7032 58.4893 60.9542 58.3335 62.1922C58.2155 63.1276 57.6793 63.8536 56.8907 64.3753C54.8215 65.7441 52.7605 67.1259 50.675 68.4669C49.1452 69.4497 47.4679 68.7302 47.1171 66.9477C46.9121 65.9076 46.7908 64.8528 46.6154 63.7016C50.9849 62.8103 54.9264 60.9706 58.6729 58.2461Z",
    fill: "url(#paint4_radial_2011_26)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6945 38.341C36.0252 42.0499 34.1381 45.937 33.2527 50.3769C31.9853 50.166 30.7343 50.0482 29.5374 49.7326C28.2273 49.3892 27.5748 47.785 28.3028 46.6239C29.762 44.2935 31.277 41.9926 32.892 39.7702C33.2904 39.2224 34.1249 38.8397 34.8251 38.6975C36.0154 38.4522 37.2598 38.4587 38.6945 38.341Z",
    fill: "url(#paint5_radial_2011_26)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3715 59.9158C38.096 60.359 37.9518 60.7204 37.6993 60.9755C35.2251 63.4693 32.7362 65.9501 30.2408 68.4227C29.6128 69.0442 28.8848 69.0621 28.3683 68.5209C27.8732 68.0025 27.8978 67.3091 28.493 66.7122C30.9917 64.2036 33.5019 61.7081 36.0088 59.2077C36.4351 58.7825 36.9549 58.5683 37.4796 58.9002C37.8304 59.1227 38.0534 59.5413 38.3715 59.9158Z",
    fill: "url(#paint6_radial_2011_26)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1373 61.6623C28.8225 61.3974 28.3569 61.1881 28.2323 60.8545C28.0945 60.4865 28.1044 59.8471 28.3388 59.592C29.6866 58.1366 31.0966 56.7351 32.5411 55.3712C33.0297 54.9101 33.6757 54.9722 34.161 55.4693C34.6463 55.9648 34.6922 56.5928 34.2184 57.085C32.8625 58.498 31.4623 59.87 30.0571 61.2339C29.8604 61.4252 29.5341 61.4841 29.1373 61.6623Z",
    fill: "url(#paint7_radial_2011_26)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5138 69C36.199 68.7433 35.7301 68.5405 35.6006 68.2069C35.4579 67.8406 35.4579 67.1979 35.6908 66.946C37.0385 65.489 38.4518 64.0908 39.8881 62.7204C40.3833 62.2494 41.0145 62.305 41.5064 62.7956C41.9983 63.2878 42.0491 63.9272 41.5867 64.4146C40.239 65.834 38.8355 67.2028 37.432 68.5683C37.2336 68.7596 36.9073 68.8201 36.5138 69Z",
    fill: "url(#paint8_radial_2011_26)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.748 43.8962C54.6969 43.8863 53.0786 42.2363 53.0983 40.1758C53.118 38.1791 54.7674 36.5454 56.7677 36.5405C58.7975 36.5372 60.4797 38.2134 60.4748 40.2347C60.4683 42.2657 58.7975 43.906 56.748 43.8962Z",
    fill: "url(#paint9_radial_2011_26)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2011_26",
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8178FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2011_26",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9909 31.9457) scale(66.7143 66.7141)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2011_26",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.996 40.9763) scale(29.1875 29.1874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2011_26",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.996 40.9763) scale(29.1875 29.1874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2011_26",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.996 40.9763) scale(29.1875 29.1874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2011_26",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.996 40.9763) scale(29.1875 29.1874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2011_26",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.996 40.9763) scale(29.1875 29.1874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2011_26",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.996 40.9763) scale(29.1875 29.1874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2011_26",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.996 40.9763) scale(29.1875 29.1874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2011_26",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.996 40.9763) scale(29.1875 29.1874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.c8a227123c63793474d0ddd13771081c.svg";
export { ForwardRef as ReactComponent };